class AbstractStore {
    constructor(props) {
        this.agGridProps = props;
        this.columnAliasPath = props.colDef.aliasPath;
        this.dataIndex = props.colDef.dataIndex;

        if (this.constructor === AbstractStore) {
            // Abstract class can not be constructed.
            throw new TypeError("Can not construct abstract class.");
        }

        // if (this.functionName === AbstractStore.prototype.functionName) {
        //     throw new TypeError("Please implement abstract method functionName.");
        // }

        // autoBind(this);
    }
}


export default AbstractStore;